<template>
    <div class="tsa-PayRetainDialog" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="close">
                <span class="el-icon-close" @click="giveUp"></span>
            </div>
            <img class="icon" src="../../assets/images/buy/payFail.png" alt="">
            <h3>您的订单尚未完成支付！</h3>
            <h4>该订单为您保留24小时，超时将自动关闭！</h4>
            <div class="bottom-group">
                <img v-if="payLeave.imageUrl" :src="payLeave.imageUrl" @click="useCoupons" alt="" srcset="">
                <button v-else @click="useCoupons">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            show: false,
            payLeave: {}
        }
    },
    methods: {
        giveUp () {
            
        },
        useCoupons () {

        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-PayRetainDialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        .mask {
            width: 100%;
            height: 100%;
            background: rgba(0,0,0, 0.74);
        }
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 30px;
            box-sizing: border-box;
            width: 520px;
            // height: 540px;
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 1px rgba(7,12,20,0.12);
            border-radius: 12px;
            .close {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                .el-icon-close {
                    font-size: 16px;
                    color: #979797;
                    cursor: pointer;
                    &:hover {
                        color: #005CE6;
                    }
                }
                
            }
            .icon {
                width: 100px;
                height: auto;
            }
            h3 {
                font-weight: bold;
                color: #151B26;
                font-size: 20px;
                margin-bottom: 18px;
            }
            h4 {
                font-size: 16px;
                color: #151B26;
                margin-bottom: 18px;
            }
            .bottom-group {
                img {
                    width: 100%;
                    height: 264px;
                    cursor: pointer;
                    border-radius: 8px;
                }
                button {
                    width: 120px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 6px;
                    border: 1px solid #005CE6;
                    font-size: 14px;
                    color: #2468F2;
                    cursor: pointer;
                    margin-top: 22px;
                    margin-bottom: 13px;
                    &:hover {
                        background: #f9f7f7;
                    }
                }
            }
        }
    }
</style>